
import { openMessage } from '@/utils/helpers'
import {
  CodeTypeSetting,
  ConfigId,
  defaultCodeTypeSetting,
  isKeyenceEnterpriseBrowser,
  KeyenceModule,
  ScanResult,
} from '@/utils/keyenceHT/keyenceModules'
import { Vue } from 'vue-class-component'

export default class KeyenceHTScannerMixin extends Vue {
  backupCodeTypeSetting: CodeTypeSetting = defaultCodeTypeSetting

  /**
   * Start scanning with Keyence HT scanner
   * @param onScanSuccess - Callback function to handle successful scan result
   * @param messageKey - Optional translation key for the message to display (defaults to 'keyenceModule.messages.scanBarcode')
   */
  async startScanWithKeyenceHT(
    onScanSuccess: (detectedText: string) => void,
    messageKey = 'keyenceModule.messages.scanBarcode',
    shouldStartRead = true
  ) {
    this.backupCodeTypeSetting = KeyenceModule.Scanner.getConfig(ConfigId.CodeType) as CodeTypeSetting
    KeyenceModule.Scanner.setConfig(ConfigId.CodeType, defaultCodeTypeSetting)

    KeyenceModule.Scanner.clearReadCallback()
    KeyenceModule.Scanner.setReadCallback('keyenceHandyTerminalScanResultCallback')
    window.keyenceHandyTerminalScanResultCallback = (result: ScanResult) => {
      if (result.mDecodeResult !== 'SUCCESS') {
        return
      }
      const resultString =
        typeof result.mStringData === 'string' ? result.mStringData : result.mStringData[0].toString()
      const detectedText = resultString?.trim() || ''
      onScanSuccess(detectedText)
    }

    openMessage(this.$t(messageKey), 'info', 4000)

    if (shouldStartRead) {
      KeyenceModule.Scanner.startRead()
    }
  }

  /**
   * Restore the backup code type setting when component is unmounted
   */
  unmountedKeyenceHTScanner() {
    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      KeyenceModule.Scanner.clearReadCallback()
      KeyenceModule.Scanner.setConfig(ConfigId.CodeType, this.backupCodeTypeSetting)
    }
  }
}
